__turbopack_context__.v({
  "dot": "_0NNQaW_dot",
  "light": "_0NNQaW_light",
  "white": "_0NNQaW_white",
});
